import {useSetQueryParams, useQueryParams} from '@eitje/bridge'
import {Layout, Text} from '~/components'
import utils from '@eitje/utils'
import {Delta} from '../delta'
import './index.less'

export const GraphAggregateCard = ({name, docsId, infoIconMessage, value, delta}) => {
	const {graph_name} = useQueryParams()
	const setQueryParams = useSetQueryParams()

	const isActive = graph_name === name

	const infoIconMessageProps = (docsId || infoIconMessage) && {
		title: `dashboard.card.${name}.title`,
		body: `dashboard.card.${name}.body`,
		...(docsId && {type: 'docs', docsId}),
		...infoIconMessage,
	}

	const className = utils.makeCns('graph-aggregate-card', isActive && 'active')

	return (
		<Layout
			className={className}
			padding={12}
			vertical="start"
			horizontal="center"
			direction="vertical"
			borderRadius={8}
			border
			onClick={() => setQueryParams({graph_name: name})}
		>
			<Text color="dark-grey" weight="medium" t={`dashboard.card.${name}.title`} infoIconMessage={infoIconMessageProps} truncate />
			<Layout vertical="center">
				<Text fontSize={18} weight="semiBold">
					{value}
				</Text>
				{delta && <Delta value={delta.value} positive={delta.positive} negative={delta.negative} compact fontSize={18} weight="semiBold" />}
			</Layout>
		</Layout>
	)
}
